import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { getProjectById } from '../../mockData';
import './index.css';
import './index.tablet.css';
import './index.mobile.css';

function ProjectDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  
  // 获取当前语言
  const currentLang = i18n.language || 'zh';
  
  // 获取项目详情
  const projectItem = getProjectById(Number(id));
  
  // 云朵背景图路径
  const cloudBgUrl = `${process.env.PUBLIC_URL}/image/云朵背景.jpg`;
  
  // 如果找不到项目，显示错误信息
  if (!projectItem) {
    return (
      <div className="project-detail-container">
        <div 
          className="project-detail-cloud-bg"
          style={{
            backgroundImage: `url(${cloudBgUrl})`
          }}
        />
        <div className="project-detail-section-container">
          <div className="project-detail-error">
            <h2>{t('projectDetail.notFound')}</h2>
            <button 
              className="project-detail-back-button"
              onClick={() => navigate('/projects')}
            >
              {t('projectDetail.backToList')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="project-detail-container">
      <div 
        className="project-detail-cloud-bg"
        style={{
          backgroundImage: `url(${cloudBgUrl})`
        }}
      />
      <div className="project-detail-section-container">
        <div className="project-detail-content">
          <div className="project-detail-header">
            <h1 className="project-detail-article-title">
              {projectItem.title[currentLang]}
            </h1>
            <p className="project-detail-date">{projectItem.startDate}</p>
          </div>
          
          <div className="project-detail-body">
            <div className="project-detail-description">
              <ReactMarkdown
                components={{
                  a: ({ node, ...props }) => (
                    <a 
                      {...props} 
                      className="project-detail-markdown-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {props.children}
                      <img 
                        src={`${process.env.PUBLIC_URL}/image/跳转.png`} 
                        alt="jump" 
                        className="project-detail-link-icon"
                      />
                    </a>
                  ),
                }}
              >
                {projectItem.description[currentLang]}
              </ReactMarkdown>
            </div>
            
            <div className="project-detail-image">
              <img src={projectItem.image} alt={projectItem.title[currentLang]} />
            </div>
          </div>
          {/* eslint-disable-next-line */}
          { id == 1 && (
            <div className="project-detail-apply-link">
              <span 
                className="project-detail-link-text"
                onClick={() => navigate('/apply-info')}
              >
                {t('projectDetail.applyLink')}
                <img 
                  src={`${process.env.PUBLIC_URL}/image/跳转.png`} 
                  alt="jump" 
                  className="project-detail-link-icon"
                />
              </span>
            </div>
          ) }
          </div>
      </div>
    </div>
  );
}

export default ProjectDetail;

